export const ERROR_TYPES = {
  COMPONENT_LOADING: 'COMPONENT_LOADING',
  LOCALSTORAGE: 'LOCALSTORAGE',
  API: 'API'
};
export const ERROR_SOURCES = {
  FEEDBACK_SURVEY_PROMPT: 'FeedbackSurveyPrompt',
  SURVEY_UTILS: 'surveyUtils',
  SURVEY_API: 'surveyApi',
  LANGUAGE_LOADER: 'useLanguageLoader'
};